// This file contains compile-time defined variables.

export const NAME: string = "zs-extract";

export const VERSION: string = "1.4.2";
